import { useMutation } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { ExtractedFactFromImage } from '../types/backend-dto-types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface ExtractFactsFromImageRequest {
  imageBase64: string;
}

interface UseExtractFactsFromImageOptions {
  onSuccess?: (data: ExtractedFactFromImage[]) => void;
  onError?: (error: Error) => void;
}

export const useExtractFactsFromImage = (options?: UseExtractFactsFromImageOptions) => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation<ExtractedFactFromImage[], Error, { caseId: string; docId: string } & ExtractFactsFromImageRequest>(
    {
      mutationFn: async ({ caseId, docId, imageBase64 }) => {
        const fetchConfig = getFetchConfig({
          method: FetchMethod.POST,
          data: {
            imageBase64,
          },
        });

        const response = await fetch(
          `${APIBaseChronos}/api/case/${caseId}/docs/${docId}/facts-from-image`,
          fetchConfig,
        );

        if (!response.ok) {
          throw new Error('Failed to extract facts from image');
        }

        const data = await response.json();
        return data as ExtractedFactFromImage[];
      },
      onSuccess: (data) => {
        options?.onSuccess?.(data);
      },
      onError: (error) => {
        options?.onError?.(error);
      },
    },
  );
};
